import store from '@/store';
import { getPlatformInfo } from '@/utils/deviceUtils';
import _ from 'lodash';
import DDLogs from '@/DDLogs';
import config from './config';

/* eslint-disable */
export default {
  install(Vue, options) {
    includeIntercom();
  },

  async boot(customerId, householdName, extraAttributes) {
    const { intercomEnabled, appId, normalizedExtraAttributes } = _getIntercomAttributes(extraAttributes);
    if (intercomEnabled === "true") {
      if (!window.Intercom || typeof window.Intercom !== 'function') {
        DDLogs.error('[Intercom Debug] Intercom not available on window during boot');
        return;
      }
      window.Intercom('boot', {
        app_id: appId,
        user_id: customerId,
        name: householdName,
        hide_default_launcher: true,
        ...normalizedExtraAttributes,
      })

      this.initIntercomEvents();
    }
  },
  show() {
    if (window.Intercom && typeof window.Intercom === 'function') {
      DDLogs.info('[Intercom Debug] show clicked and Intercom available on window');
      window.Intercom('show');
    } else {
      DDLogs.error('[Intercom Debug] show attempted but Intercom not available on window');
    }
  },
  hide() {
    window.Intercom('hide');
  },
  async update(customerId, householdName, extraAttributes) {
    const { intercomEnabled, appId, normalizedExtraAttributes } = _getIntercomAttributes(extraAttributes);
    if (intercomEnabled === "true") {
      if (!window.Intercom || typeof window.Intercom !== 'function') {
        DDLogs.error('[Intercom Debug] Intercom not available on window during update');
        return;
      }
      window.Intercom('update', {
        app_id: appId,
        user_id: customerId,
        name: householdName,
        hide_default_launcher: true,
        ...normalizedExtraAttributes,
      })

      this.initIntercomEvents();
    }
  },
  hideLauncher() {
    window.Intercom('update', {
      'hide_default_launcher': true
    });
  },
  showLauncher() {
  },
  showNewMessage(prompt = '') {
    window.Intercom('showNewMessage', prompt);
  },
  initIntercomEvents() {
    if (!window.Intercom) {
      return;
    }

    const { platform, appVersion } = getPlatformInfo();
    window.Intercom('onShow', function() {
      window.Intercom('update', { user_platform: platform, appVersion: appVersion });
      store.commit('intercom/setIsOpen', true);
    });

    window.Intercom('onHide', function() {
      store.commit('intercom/setIsOpen', false);
    });
    //in order to init the launcher for calculating unread messages for the first time
    // this won't actually show the launcher
    window.Intercom('show');

    // Only hide if shouldShow is false in store
    if (!store.state.intercom.showOnInit) {
      window.Intercom('hide');
    }

    window.Intercom('onUnreadCountChange', (unreadCount) => {
      store.commit('intercom/setUnreadMessages', unreadCount);
    });
  }
};
function includeIntercom() {
  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i = function() {
      i.c(arguments);
    };
    i.q = [];
    i.c = function(args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function() {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/APP_ID';
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}

function _getIntercomAttributes(extraAttributes) {
  const { intercomEnabled, intercomProdAppId } = config.get();
  const normalizedExtraAttributes = _.mapKeys(extraAttributes, (v, k) => _.snakeCase(k));
  return { intercomEnabled, appId: intercomProdAppId, normalizedExtraAttributes };
}
